export const Contact = {
  Email: 'support@intellect.co',
};
